import { IInstantMessageChannelEditUserItem } from "./instantMessageChannelUserEditItem";

export class InstantMessageChannelHelper {
    static getFixedName = (users: IInstantMessageChannelEditUserItem[], userCode: string): string => {
        const otherUsers = users.filter(i => i.userCode !== userCode);
        if (otherUsers.length === 1) {
            return otherUsers[0].getName();
        } else {
            return null;
        }
    };

    static getPicture = (users: IInstantMessageChannelEditUserItem[], picture: string, userCode: string): string => {
        if (picture) {
            return picture;
        }
        const otherUsers = users.filter(i => i.userCode !== userCode);
        if (otherUsers.length > 1) {
            return "";
        } else if (otherUsers.length > 0) {
            return otherUsers[0].picture;
        } else {
            return "";
        }
    };

    static getPictureClass = (users: IInstantMessageChannelEditUserItem[], picture: string, userCode: string): string => {
        if (InstantMessageChannelHelper.getPicture(users, picture, userCode)) {
            return "";
        } else {
            const otherUsers = users.filter(i => i.userCode !== userCode);
            return otherUsers.length > 1 ? "icon instantMessageGroup" : "";
        }
    };

    static getAvatarId = (users: IInstantMessageChannelEditUserItem[], picture: string, userCode: string): string => {
        if (InstantMessageChannelHelper.getPicture(users, picture, userCode)) {
            return "";
        } else {
            const otherUsers = users.filter(i => i.userCode !== userCode);
            if (otherUsers.length > 1) {
                return "";
            } else if (otherUsers.length > 0) {
                return otherUsers[0].userCode;
            } else {
                return "";
            }
        }
    };
}